// extracted by mini-css-extract-plugin
export var quoteBox = "Testing-module--quote-box--20529";
export var quoteContent = "Testing-module--quote-content--712e9";